import SearchIcon from '@mui/icons-material/Search'
import { Grid } from '@mui/material'
import Button from '@mui/material/Button'
import { useState } from 'react'
import { TextField, MenuItem } from '@mui/material'

import { Dayjs } from 'dayjs'
import {
  EOrderDateType,
  EOrderStatus,
  EOrderType,
} from '../../../../../types/order'
import DateRangePicker from '../../../../../components/DateRangePicker'
import { SHIPPING_STATUS } from '../../../../../constants/shipping-status'
import { useUser } from '../../../../../hooks/useUser'
import { ITikTokAccount } from '../../../../../types/tiktok'

export interface IFilterMapped {
  page?: number
  perPage?: number
  search?: string
  order_status?:
    | 'UNPAID'
    | 'ON_HOLD'
    | 'AWAITING_SHIPMENT'
    | 'PARTIALLY_SHIPPING'
    | 'AWAITING_COLLECTION'
    | 'IN_TRANSIT'
    | 'DELIVERED'
    | 'COMPLETED'
    | 'CANCELLED'
  create_time_ge?: number
  create_time_lt?: number
  shipping_type?: 'TIKTOK' | 'SELLER'
  dateType?: EOrderDateType
  cursor?: string
  shopId?: string
}

interface FilterProps {
  filter: IFilterMapped
  tiktokAccounts: ITikTokAccount[]
  onFilterChange: (filter: IFilterMapped) => void
  onSearch: (filter: IFilterMapped) => void
  showStatusCall?: boolean
  onDownload?: (date: Dayjs) => void
}

const OrderFilter = (props: FilterProps) => {
  const {
    tiktokAccounts = [],
    onFilterChange,
    filter,
    onSearch,
    showStatusCall = false,
    onDownload,
  } = props
  const { order_status, shipping_type } = filter
  const [isOpenedFilterDrawer, setIsOpenedFilterDrawer] =
    useState<boolean>(false)

  const { merchant } = useUser()

  const orderStatusOptions = [
    { value: 'UNPAID', label: 'ยังไม่ได้ชำระเงิน' },
    { value: 'ON_HOLD', label: 'รอดำเนินการ' },
    { value: 'AWAITING_SHIPMENT', label: 'รอจัดส่ง' },
    { value: 'PARTIALLY_SHIPPING', label: 'จัดส่งบางส่วน' },
    { value: 'AWAITING_COLLECTION', label: 'รอรับสินค้า' },
    { value: 'IN_TRANSIT', label: 'กำลังจัดส่ง' },
    { value: 'DELIVERED', label: 'จัดส่งสำเร็จ' },
    { value: 'COMPLETED', label: 'เสร็จสิ้น' },
    { value: 'CANCELLED', label: 'ยกเลิก' },
  ]

  const shippingTypeOptions = [
    { value: 'TIKTOK', label: 'จัดส่งผ่าน TikTok' },
    { value: 'SELLER', label: 'จัดส่งเอง' },
  ]

  const handleDateChange = (startDate?: string, endDate?: string) => {
    const create_time_ge = startDate ? new Date(startDate).getTime() : undefined
    const create_time_lt = endDate ? new Date(endDate).getTime() : undefined

    //1623812664 -> option 1
    //1740762000000 -> option 2
    // convert option 2 to option 1
    if (create_time_ge && create_time_lt) {
      const create_time_ge_option1 = create_time_ge / 1000
      const create_time_lt_option1 = create_time_lt / 1000
      onFilterChange({
        ...filter,
        create_time_ge: create_time_ge_option1,
        create_time_lt: create_time_lt_option1,
      })
    }

    // onFilterChange({ ...filter, create_time_ge, create_time_lt })
  }

  return (
    <>
      <Grid container spacing={1} mb={2}>
        <Grid item xs={12} lg={2}>
          <TextField
            select
            fullWidth
            label="บัญชี"
            value={filter.shopId || ''}
            onChange={(e) => {
              onFilterChange({
                ...filter,
                shopId: e.target.value,
              })
            }}
          >
            {tiktokAccounts.map((account) => (
              <MenuItem key={account.shopId} value={account.shopId}>
                {account.sellerName}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} lg={2}>
          <TextField
            select
            fullWidth
            label="สถานะ"
            value={order_status || ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                order_status: e.target.value as IFilterMapped['order_status'],
              })
            }
          >
            <MenuItem value="">All</MenuItem>
            {orderStatusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} lg={2}>
          <TextField
            select
            fullWidth
            label="ประเภทการจัดส่ง"
            value={shipping_type || ''}
            onChange={(e) =>
              onFilterChange({
                ...filter,
                shipping_type: e.target.value as IFilterMapped['shipping_type'],
              })
            }
          >
            <MenuItem value="">All</MenuItem>
            {shippingTypeOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} lg={4}>
          <DateRangePicker
            gap={1}
            startDate={
              filter.create_time_ge
                ? new Date(filter.create_time_ge * 1000).toISOString()
                : undefined
            }
            endDate={
              filter.create_time_lt
                ? new Date(filter.create_time_lt * 1000).toISOString()
                : undefined
            }
            onChange={handleDateChange}
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <Button
            color="primary"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => onSearch(filter)}
            sx={{ height: '100%' }}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export default OrderFilter
